import React from 'react';
import img1 from '../InnerArea/1.png'
import img1_bg from '../InnerArea/8h3.png'
import img2 from '../InnerArea/2-bg.png'
import img3 from '../InnerArea/3.png'
import img4 from '../InnerArea/4.png'
import Bg1 from '../ProductSlider/Images/bg1.png';
import { Link } from 'react-router-dom';

import Check from '../InnerArea/check2.svg'
import checkout1 from '../InnerArea/checkout/1.svg'
import checkout2 from '../InnerArea/checkout/2.svg'
import checkout3 from '../InnerArea/checkout/3.svg'
import checkout4 from '../InnerArea/checkout/4.svg'
import checkout5 from '../InnerArea/checkout/5.svg'


function InnerArea() {

    const section1 =
    {
        img1: img1,
        img2: img1_bg,
        title: "Work from anywhere on",
        titleSpan: ' Multiple Devices',
        description: "Access and manage your books from your computer, laptop, tablet, or smartphone anytime you choose.",
        description2: "Create access privileges so that your colleague or accountant can login and work with your data online.",
        readMoreLink: "#"
    }

    const section2 =
    {
        img: img2,
        title: "Choose from retail's best Integrated Payments",
        description: "Accept all the ways your customers want to pay, in-store, online and on-the go. Vend integrates with leading payment providers for a seamless checkout experience.",
        additionalItems: [
            { text: "Easily accept any payment type", icon: Check },
            { text: "Save time and remove double handling", icon: Check },
            { text: "Enhance the customer experience", icon: Check },
            { text: "Open your store with online payments", icon: Check }
        ],
        paymentMethods: [
            checkout1,
            checkout2,
            checkout3,
            checkout4,
            checkout5
        ]
    }

    const section3 =
    {
        img: img3,
        title: `from the retail professionals`,
        titleSpan: 'Friendly support',
        description: "Get our expert team working for you. Enjoy award winning 24/7 support from retail professionals. We’re ready to get your business set up just right, and keep you growing from there. Get our expert team working for you."
    }

    const section4 = {
        img: img4,
        title: `The for small business management`,
        titleSpan: 'all-in-one solution',
        description: "Business management is the cornerstone of FusionHub. Process payments, generate reports, manage your employees and organize your stock with inventory software.",
        listItems1: ["Point of Sale", "Order Management", "Split Payments", "Ingredients Management", "Tax Management", "Cash Discount"],
        listItems2: ["Point of Sale", "Order Management", "Split Payments", "Ingredients Management", "Tax Management", "Cash Discount"]
    };

    return (
        <>
            <div className="inner-area pd-top-120">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-7 col-md-6 order-md-12 mb-md-0 mb-4">
                            <div className="sb-animate-img">
                                <div className="thumb">
                                    <img src={section1.img2} alt="img" />
                                </div>
                                <div className="thumb-2">
                                    <img src={section1.img1} alt="img" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-5 col-md-6 order-md-1 align-self-center">
                            <div className="section-title style-two text-md-left text-center mb-0">
                                <h2 className="title">{section1.title}<span>{section1.titleSpan}</span></h2>
                                <p>{section1.description}</p>
                                <p>{section1.description2}</p>
                                <Link className="read-more" href={section1.readMoreLink}>Read More <i className="la la-long-arrow-right"></i></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="business-time pd-top-120">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-5 col-lg-6 sbimg-center-align pb-4">
                            <div className="mask-bg-wrap mask-bg-img-1">
                                <div className="thumb">
                                    <img src={section2.img} alt="service" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-5 col-lg-6 offset-xl-1 desktop-center-item">
                            <div className="mg-top-767-45-">
                                <div className="section-title style-two">
                                    <h2 className="title">{section2.title}</h2>
                                    <p>{section2.description}</p>
                                </div>
                                {/* Additional items */}
                                {section2.additionalItems.map((item, index) => (
                                    <div className="FusionHub-check-list" key={index}>
                                        <img src={item.icon} alt="check" />
                                        <span>{item.text}</span>
                                    </div>
                                ))}
                                {/* Payment methods */}
                                <div className="payment-method style-two">
                                    <ul className='d-flex'>
                                        {section2.paymentMethods.map((method, index) => (
                                            <li key={index}>
                                                <Link href="#"><img src={method} alt="img" /></Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pd-top-120">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-7 col-md-6 order-lg-12 pb-4 pb-md-0">
                            <div className="mask-bg-wrap mask-bg-img-2">
                                <div className="thumb">
                                    <img src={section3.img} alt="service" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-5 col-md-6 order-lg-1 align-self-center">
                            <div className="section-title style-two mb-0">
                                <h2 className="title"><span>{section3.titleSpan}</span>{section3.title}</h2>
                                <p>{section3.description}</p>
                                <Link className="read-more" href={section1.readMoreLink}>Read More <i className="la la-long-arrow-right"></i></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="sbs-what-FusionHub pd-default-120 mg-top-105" style={{ backgroundImage: `url(${Bg1})` }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 desktop-center-item">
                            <img src={section4.img} alt="img" />
                        </div>
                        <div className="col-lg-6 desktop-center-item">
                            <div className="desktop-center-area">
                                <div className="section-title style-two">
                                    <h2 className="title">The <span>{section4.titleSpan}</span> {section4.title}</h2>
                                    <p>{section4.description}</p>
                                </div>
                                <div className="row">
                                    <div className="col-md-5">
                                        <ul>
                                            {section4.listItems1.map((item, index) => (
                                                <li key={index} className="FusionHub-check-list style-two">
                                                    <span>{item}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="col-md-5">
                                        <ul>
                                            {section4.listItems2.map((item, index) => (
                                                <li key={index} className="FusionHub-check-list style-two">
                                                    <span>{item}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            
        </>
    );
}

export default InnerArea;
